module.exports = __webpack_public_path__ + "candidate_bg.cb271c25f30b3d073e3f";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/assets/images/candidate_bg.jpg
// module id = ../../../../../src/assets/images/candidate_bg.jpg
// module chunks = styles